.dynamic-skeleton-loader-container {
  @apply max-w-540 px-6 pt-3 pb-5 rounded-lg text-white font-open-sans box-border min-h-260;

  background-color: var(--clrs-bg-dynamic-entry);
}
